/** Inline style — iOS Safari will not auto-zoom inputs at 16px+. */
export const MOBILE_INPUT_FONT_SIZE_STYLE = { fontSize: "16px" };

/** Use on all modal/page inputs; pairs with global CSS + viewport max-scale. */
export const MOBILE_FORM_FIELD_CLASS =
  "w-full rounded-xl border border-slate-200 px-4 py-2.5 text-[16px] text-slate-900 placeholder:text-slate-400 focus:border-[#38513b] focus:outline-none focus:ring-1 focus:ring-[#38513b]";
